import React, { useState, useEffect, useCallback, useMemo } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import {MenuItem,} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import TextField from "@mui/material/TextField";
import Layout from "./layout";
import axios from "axios";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import TableSortLabel from "@mui/material/TableSortLabel";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import { visuallyHidden } from "@mui/utils";
import TableFooter from "@mui/material/TableFooter";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Checkbox from "@mui/material/Checkbox";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import ProductIcon from "../images/product.png";
import EditProductIcon from "../images/editProduct.png"
import { DialogActions,DialogContentText } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { CircularProgress } from '@mui/material';

export default function Brand() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("product_id");
  const [isAddCategoryModal, setisAddCategoryModal] = useState(false);

  const [userId, setUserId] = useState();

  const [productId, setProductId] = useState();
  const [products, setProducts] = useState([]);

  const [category, setCategory] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [categoryId, setCategoryId] = useState(undefined);

  const [brand, setBrand] = useState([]);
  const [brandName, setBrandName] = useState("");
  const [brandId, setBrandId] = useState();

  const [productName, setProductName] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [price, setPrice] = useState();
  const [quantity, setQuantity] = useState(0);

  const [attribute, setAttribute] = useState([]);
  const [attributeName, setAttributeName] = useState("");
  const [attributeId, setAttributeId] = useState(undefined);

  const [attributeValue, setAttributeValue] = useState([]);
  const [attributeValueName, setAttributeValueName] = useState("");
  const [attributeValueId, setAttributeValueId] = useState();

  const [UM, setUM] = useState([]);
  const [UMName, setUMName] = useState("");
  const [UMId, setUMId] = useState();

  const [categoryError, setCategoryError] = useState();
  const [brandError, setBrandError] = useState();
  const [productNameError, setProductNameError] = useState();
  const [attributeError, setAttributeError] = useState();
  const [attributeValueError, setAttributeValueError] = useState();
  const [UMError, setUMError] = useState();
  const [priceError, setPriceError] = useState();
  const [quantityError, setQuanityError] = useState();

  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarMessageColor, setSnackbarMessageColor] = useState("");
  const [showSnackbarMessage, setShowSnackbarMessage] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state
  const [isLoading, setIsLoading] = useState(false);
  const [originalProductData, setOriginalProductData] = useState(null); // Store original data for comparison

  // Function to check if product data has changed
const hasProductChanged = () => {
  if (!originalProductData) return true; // If no original data, consider it as changed
  
  // Compare relevant fields
  return (
    productName.trim() !== originalProductData.product_name ||
    categoryId !== originalProductData.category_id ||
    brandId !== originalProductData.brand_id ||
    attributeId !== originalProductData.attribute_id ||
    attributeValueId !== originalProductData.attribute_value_id ||
    UMId !== originalProductData.measurement_unit_id ||
    Number(price) !== Number(originalProductData.price) ||
    Number(quantity) !== Number(originalProductData.quantity) ||
    (productDescription || "").trim() !== (originalProductData.description || "").trim()
  );
};

  const handleSelectCheckBox = (row) => {
    setSelectedProducts((prevSelected) => {
      if (prevSelected.includes(row.product_id)) {
        return prevSelected.filter((id) => id !== row.product_id); // Deselect
      } else {
        return [...prevSelected, row.product_id]; // Select
      }
    });
  };
 const navigate = useNavigate();
const handleExport = (selectedProducts) => {
  fetch(`${process.env.REACT_APP_JHS_DEVELOPMENT}/products/generateBarCode`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ productIds: selectedProducts }), // Pass product IDs
  })
    .then((response) => {
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect if unauthorized
        return; // Stop further execution
      }
      if (response.ok) {
        return response.blob();
      }
      throw new Error('Failed to export products');
    })
    .then((blob) => {
      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Create an anchor element to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.download = `barcodes_${new Date().toISOString().slice(0, 10)}.pdf`; // Name of the downloaded PDF file
      link.click(); // Trigger the download

      // Optionally, revoke the object URL after the download is triggered
      window.URL.revokeObjectURL(url);
      setSelectedProducts([])
    })
    .catch((error) => {
      console.error('Error exporting products:', error);
      setOpenDeleteDialog(true);
    });
  }
  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } }
        );

        if (response.status === 200) {
          setUserId(response.data.user.user_id);
         
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchUserData();
  }, []);

  // Create memoized maps for faster O(1) lookups in dropdowns
  const categoryNameToIdMap = React.useMemo(() => {
    const map = new Map();
    category.forEach((cat) => map.set(cat.category_name, cat.category_id));
    return map;
  }, [category]);

  const brandNameToIdMap = React.useMemo(() => {
    const map = new Map();
    brand.forEach((br) => map.set(br.brand_name, br.brand_id));
    return map;
  }, [brand]);

  const attributeNameToIdMap = React.useMemo(() => {
    const map = new Map();
    attribute.forEach((attr) => map.set(attr.attribute_name, attr.attribute_id));
    return map;
  }, [attribute]);

  const attributeValueToIdMap = React.useMemo(() => {
    const map = new Map();
    attributeValue.forEach((val) => map.set(val.attribute_value, val.attribute_value_id));
    return map;
  }, [attributeValue]);

  const umNameToIdMap = React.useMemo(() => {
    const map = new Map();
    UM.forEach((unit) => map.set(unit.measurement_unit_name, unit.measurement_unit_id));
    return map;
  }, [UM]);

  const handleChangeUM = useCallback((event) => {
    const selectedUM = event.target.value;
    setUMName(selectedUM);
    setUMId(umNameToIdMap.get(selectedUM));
    setUMError("");
  }, [umNameToIdMap]);

  const handleChangeCategory = useCallback((event) => {
    const selectedCategory = event.target.value;
    setCategoryName(selectedCategory);
    setCategoryId(categoryNameToIdMap.get(selectedCategory));
    setCategoryError("");
  }, [categoryNameToIdMap]);

  const handleChangeBrand = useCallback((event) => {
    const selectedBrand = event.target.value;
    setBrandName(selectedBrand);
    setBrandId(brandNameToIdMap.get(selectedBrand));
    setBrandError("");
  }, [brandNameToIdMap]);

  const handleChangeAttribute = useCallback((event) => {
    const selectedAttribute = event.target.value;
    setAttributeName(selectedAttribute);
    setAttributeId(attributeNameToIdMap.get(selectedAttribute));
    setAttributeError("");
  }, [attributeNameToIdMap]);

  const handleChangeAttributeValue = useCallback((event) => {
    const selectedAttributeValue = event.target.value;
    setAttributeValueName(selectedAttributeValue);
    setAttributeValueId(attributeValueToIdMap.get(selectedAttributeValue));
    setAttributeValueError("");
  }, [attributeValueToIdMap]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // 500ms debounce for better performance

    return () => clearTimeout(timer);
  }, [searchQuery]);

  // Memoize sorting comparator functions
  const getComparator = useCallback((order, orderBy) => {
    const descendingComparator = (a, b) => {
      if (b[orderBy] < a[orderBy]) return -1;
      if (b[orderBy] > a[orderBy]) return 1;
      return 0;
    };
    
    return order === "desc"
      ? (a, b) => descendingComparator(a, b)
      : (a, b) => -descendingComparator(a, b);
  }, []);

  // OPTIMIZATION: Pre-compute lookup maps for O(1) access
  const productNameToIdMap = useMemo(() => {
    const map = new Map();
    products.forEach((p) => map.set(p.product_name?.toLowerCase(), p.product_id));
    return map;
  }, [products]);

  // Fetch all initial data on component mount
  useEffect(() => {
    fetchAllInitialData();
  }, [navigate]);

  const fetchAllInitialData = async () => {
    try {
      setLoading(true);
      const [productsRes, categoryRes, attributeRes, uomRes] = await Promise.all([
        fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/products/getProducts", {
          method: "GET",
          headers: { "Content-type": "application/json" },
          credentials: 'include',
        }),
        fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/category/getCategory", {
          method: "GET",
          headers: { "Content-type": "application/json" },
          credentials: 'include',
        }),
        fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/products/getAttribute", {
          method: "GET",
          headers: { "Content-type": "application/json" },
          credentials: 'include',
        }),
        fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/products/getUOM", {
          method: "GET",
          headers: { "Content-type": "application/json" },
          credentials: 'include',
        })
      ]);

      // Handle 401 errors
      if (productsRes.status === 401) {
        navigate("/signin");
        return;
      }

      const [products, categories, attributes, uom] = await Promise.all([
        productsRes.json(),
        categoryRes.json(),
        attributeRes.json(),
        uomRes.json()
      ]);

      setProducts(products);
      setCategory(categories);
      setAttribute(attributes);
      setUM(uom);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Separate function to refetch products only
  const getProducts = useCallback(async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/products/getProducts",
        {
          method: "GET",
          headers: { "Content-type": "application/json" },
          credentials: 'include',
        }
      );
      if (response.status === 401) {
        navigate("/signin");
        return;
      }
      const data = await response.json();
      setProducts(data);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  }, [navigate]);

  useEffect(() => {
    if (categoryId) {
      getBrand(categoryId);
    } else {
      setBrand([]);
    }
  }, [categoryId]);

  const getBrand = async (categoryId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/products/getBrand?category_id=${categoryId}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );
      
      const data = await response.json();
      setBrand(data);
    } catch (error) {
      console.error("Error fetching brands:", error);
    }
  };

  useEffect(() => {
    if (attributeId) {
      getAttributeValue(attributeId);
    } else {
      setAttributeValue([]);
    }
  }, [attributeId]);

  const getAttributeValue = async (attributeId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/products/getAttributeValue?attribute_id=${attributeId}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );
      const data = await response.json();
      setAttributeValue(data);
    } catch (error) {
      console.error("Error fetching attribute values:", error);
    }
  };
 
  
  const saveProduct = () => {
    let categoryError = "";
    let brandError = "";
    let productNameError = "";
    let attributeError = "";
    let attributeValueError = "";
    let UMError = "";
    let quantityError = "";
    let priceError = "";
  
    // Validate Payment Date
    if (!categoryName || categoryName.trim() === "") {
      categoryError = "Category is required";
    }
    if (!brandName || brandName.trim() === "") {
      brandError = "Brand is required";
    }
    if (!productName || productName.trim() === "") {
      productNameError = "Product Name is required";
    }
    if (!attributeName || attributeName.trim() === "") {
      attributeError = "Attribute is required";
    }
    if (!attributeValueName || attributeValueName.trim() === "") {
      attributeValueError = "Attribute Value is required";
    }
    if (!UMName) {
      UMError = "Unit of Measurement is required";
    }
  
          // Validate quantity
   if (Number(quantity) < 0) {
    quantityError = "Quantity cannot be negative";
  }
    if 
    (Number(price) === 0) {
      priceError = "Price must be greater than 0";
    } else if (Number(price) < 0) {
      priceError = "Price cannot be negative";
    } else if (price == null || price === "") {
      priceError = "Price is required";
    }
  
    // Set errors and return if any validations fail
    if (
      categoryError ||
      brandError ||
      productNameError ||
      attributeError ||
      attributeValueError ||
      UMError ||
      quantityError ||
      priceError
  
    ) {
      setCategoryError(categoryError);
      setBrandError(brandError);
      setProductNameError(productNameError);
      setAttributeError(attributeError);
      setAttributeValueError(attributeValueError);
      setUMError(UMError);
      setQuanityError(quantityError);
      setPriceError(priceError);
      return; // Prevent form submission if there are errors
    }
  
    // // Reset error state after successful validation
    setCategoryError("");
    setBrandError("");
    setProductNameError("");
    setAttributeError("");
    setAttributeValueError("");
    setUMError("");
    setQuanityError("");
    setPriceError("");
   
     setIsLoading(true); // Start loading
    // Proceed with form submission
fetch(`${process.env.REACT_APP_JHS_DEVELOPMENT}/products/saveProduct`, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  credentials: 'include',
  body: JSON.stringify({
    product_name: productName.trim(),
    brand_id: brandId,
    attribute_id: attributeId,
    attribute_value_id: attributeValueId,
    measurement_unit_id: UMId,
    price: price,
    quantity: quantity || 0,
    description: productDescription,
    created_by: userId,
  }),
})
  .then((response) => {
    if (response.status === 401) {
      console.log("Unauthorized access, redirecting to Sign-In...");
      navigate("/signin"); // Redirect if unauthorized
      return; // Stop further execution
    }
    if(response.status === 409){
      setSnackbarMessage("This product already exists"); // Show "Product already exists"
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
    }
    if (!response.ok) {
      throw new Error('Failed to submit product details');
    }
    return response.json();
  })
  .then((response) => {
    handleResponse(response);
  })
  .finally(() => {
      setIsLoading(false); // Stop loading
    })
  .catch((error) => {
    console.error("Error submitting product details:", error);
    // Optionally, show a dialog or notification to the user about the error
  });

  };
  const handleResponse = (responseObject) => {
    if (responseObject.status === 200) {
      getProducts();
      setisAddCategoryModal(false);
      setSnackbarMessage(responseObject.message);
      setSnackbarMessageColor("success");
      setShowSnackbarMessage(true);
      reset();

    } else if (responseObject.status === 409) {
      setSnackbarMessage(responseObject.message); // Show "Product already exists"
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
    }
  
    if (responseObject.status === 400) {
      setSnackbarMessage(responseObject.error);
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
    }
  };
  const reset = () => {
    setCategoryName("");
    setBrandName("");
    setAttributeName("");
    setAttributeValueName("");
    setProductName("");
    setProductDescription("");
    setPrice();
    setQuantity(0);
    setUMName("");
    setCategoryId();
    setAttributeId();
   

    setCategoryError("");
    setBrandError("");
    setAttributeError("");
    setAttributeValueError("");
    setProductNameError("");
    setProductNameError("");
    setPriceError();
    setUMError("");

    setisAddCategoryModal(false);
    setProductId();
    setOriginalProductData(null); // Clear original data on reset
  };

  const editProduct = () => {
    
    let categoryError = "";
    let brandError = "";
    let productNameError = "";
    let attributeError = "";
    let attributeValueError = "";
    let UMError = "";
    let priceError = "";
  
    // Validate Payment Date
    if (!categoryName || categoryName.trim() === "") {
      categoryError = "Category is required";
    }
    if (!brandName || brandName.trim() === "") {
      brandError = "Brand is required";
    }
    if (!productName || productName.trim() === "") {
      productNameError = "Product Name is required";
    }
    if (!attributeName || attributeName.trim() === "") {
      attributeError = "Attribute is required";
    }
    if (!attributeValueName || attributeValueName.trim() === "") {
      attributeValueError = "Attribute Value is required";
    }
    if (!UMName) {
      UMError = "Unit of Measurement is required";
    }
   
    if (Number(price) === 0) {
      priceError = "Price must be greater than 0";
    } else if (Number(price) < 0) {
      priceError = "Price cannot be negative";
    } else if (price == null || price === "") {
      priceError = "Price is required";
    }
  
    // Set errors and return if any validations fail
    if (
      categoryError ||
      brandError ||
      productNameError ||
      attributeError ||
      attributeValueError ||
      UMError ||
      priceError
  
    ) {
      setCategoryError(categoryError);
      setBrandError(brandError);
      setProductNameError(productNameError);
      setAttributeError(attributeError);
      setAttributeValueError(attributeValueError);
      setUMError(UMError);
      setPriceError(priceError);
      return; // Prevent form submission if there are errors
    }
  
      // ADD THIS CHECK HERE - Check if any changes were made
    if (!hasProductChanged()) {
    setSnackbarMessage("No changes detected.");
    setSnackbarMessageColor("error");
    setShowSnackbarMessage(true);
    return;
    }

    // // Reset error state after successful validation
    setCategoryError("");
    setBrandError("");
    setProductNameError("");
    setAttributeError("");
    setAttributeValueError("");
    setUMError("");
    // setQuanityError("");
    setPriceError("");
   
    fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/products/editProduct", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      credentials: 'include',
      body: JSON.stringify({
        product_id: productId,
        product_name: productName.trim(),
        brand_id: brandId,
        attribute_id: attributeId,
        attribute_value_id: attributeValueId,
        measurement_unit_id: UMId,
        price: price,
        quantity: quantity,
        description: productDescription,
        updated_timestamp: new Date(),
        updated_by: userId,
      }),
    })
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin"); // Redirect if unauthorized
          return; // Stop further execution
        }
        if(response.status === 409){
          setSnackbarMessage("This product already exists"); // Show "Product already exists"
          setSnackbarMessageColor("error");
          setShowSnackbarMessage(true);
        }
        if (!response.ok) {
          throw new Error('Failed to edit product');
        }
        return response.json();
      })
      .then((response) => {
        handleResponse(response);
      })
      .catch((error) => {
        console.error("Error editing product details:", error);
        // Optionally, show a dialog or notification to the user about the error
      });
    
  };

  const openAddCategoryModal = (event) => {
    setisAddCategoryModal(true);
  };

  const handleClose = () => {
    setisAddCategoryModal(false);
    reset();
  };
 
  const handleCloseConfirm =()=>{
    setOpenDeleteDialog(false);
  }

  //Simran........ added pagination and sorting
  const handleChangePage = useCallback((event, newPage) => {
    setPage(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }, []);

  // OPTIMIZATION 3: Memoized sorting function with useCallback
  const handleRequestSort = useCallback((property) => {
    setOrder((prevOrder) => {
      const isAscending = orderBy === property && prevOrder === "asc";
      return isAscending ? "desc" : "asc";
    });
    setOrderBy(property);
  }, [orderBy]);

  // OPTIMIZATION 1: Ultra-optimized filtering with memoization and early exits
  const filteredRows = useMemo(() => {
    if (!products || products.length === 0) return [];

    // Quick path: no search, return all products
    if (!debouncedSearchQuery) {
      return products;
    }

    // Pre-process search terms once
    const searchTerms = debouncedSearchQuery.toLowerCase().trim().split(/\s+/).filter(Boolean);
    const hasSearchTerms = searchTerms.length > 0;

    if (!hasSearchTerms) return products;

    return products.filter((row) => {
      // Join all searchable fields into one string
      const searchableStr = [
        row.product_id?.toString().toLowerCase() || "",
        row.product_name?.toLowerCase() || "",
        row.category_name?.toLowerCase() || "",
        row.brand_name?.toLowerCase() || "",
        row.attribute_name?.toLowerCase() || "",
        row.attribute_value?.toLowerCase() || "",
        row.measurement_unit?.toString().toLowerCase() || "",
        row.price?.toString().toLowerCase() || "",
        row.quantity?.toString().toLowerCase() || "",
        row.description?.toLowerCase() || "",
      ].join(" ");

      // Every search term must match at least once
      return searchTerms.every((term) => searchableStr.includes(term));
    });
  }, [products, debouncedSearchQuery]);

  // OPTIMIZATION 2: Optimized sorting with memoization
  const sortedRows = useMemo(() => {
    if (!filteredRows || filteredRows.length === 0) return [];

    const comparator = getComparator(order, orderBy);
    return filteredRows
      .map((row, index) => ({ ...row, index: index + 1 }))
      .sort((a, b) => comparator(a, b));
  }, [filteredRows, order, orderBy, getComparator]);

  // OPTIMIZATION 4: Memoized pagination
  const paginatedRows = useMemo(() => {
    if (rowsPerPage > 0) {
      return sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    }
    return sortedRows;
  }, [sortedRows, page, rowsPerPage]);

  const handleSelectRow = (
    pId,
    pName,
    cName,
    brandName,
    attributeValue,
    attributeName,
    measurementUnit,
    price,
    quantity,
    description,
    categoryId,
    attributeId,
    brandId,
    attributeValueId,
    muId

  ) => {
 
    setProductId(pId);
    setProductName(pName);
    setCategoryName(cName);
    setBrandName(brandName);
    setAttributeName(attributeName);
    setAttributeValueName(attributeValue); // Set fee concession
    setUMName(measurementUnit);
    setPrice(price);
    setQuantity(quantity);
    setProductDescription(description); // Set the description
 
    setCategoryId(categoryId)
    setAttributeId(attributeId)
    setisAddCategoryModal(true);
    setBrandId(brandId);
    setAttributeValueId(attributeValueId);
    setUMId(muId);

      // Store original data for comparison
    setOriginalProductData({
    product_id: pId,
    product_name: pName,
    category_id: categoryId,
    brand_id: brandId,
    attribute_id: attributeId,
    attribute_value_id: attributeValueId,
    measurement_unit_id: muId,
    price: price,
    quantity: quantity,
    description: description,
    });

  };

  return (
    <>
      <Layout />
      <h1 className="title">Product</h1>

     
         <Dialog onClose={handleClose}open={isAddCategoryModal} maxWidth="xs"fullWidth={false} 
     sx={{
       '& .MuiDialog-paper': {
        width: '27%',          
        height: 'auto', 
        padding: '16px', 
        overflow: 'hidden', 
        paddingTop:'5px'
        },}}>

      <DialogTitle sx={{ position: 'relative', padding: '8px' }}>
      <span style={{ display: 'flex', alignItems: 'flex-start', color: '#0A64A2', fontSize: '1.2em' }}>
      <span style={{ display: 'inline-block', borderBottom: '2.4px solid #0A64A2', lineHeight: '1.8', width:'40em',}}>
      
      {productId? <img 
        src={EditProductIcon} 
        alt="Product Icon" 
        style={{ 
          marginRight: '0.2px', 
          height: '30px',
          color: '#0A64A2',
          right:'3px',
          position: 'relative',
          top: '0.2em',
          paddingRight:'2px'
        }} 
      />: <img 
      src={ProductIcon} 
      alt="Product Icon" 
      style={{ 
        marginRight: '0.2px', 
        height: '30px',
        color: '#0A64A2',
        right:'3px',
        position: 'relative',
        top: '0.2em',
        paddingRight:'2px'
      }} 
    />}

        <span style={{ 
        color: '#0A64A2', 
        fontSize: '0.9em', 
        left:'10px',
    }}>
      {productId ? 'Edit Product' : 'Add Product'}
    </span>
  </span>
  </span>

    <IconButton
      aria-label="close"
      onClick={handleClose}
      size="small"
      sx={{
        position: 'absolute',
        left: '92%',
        bottom: '50%',
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
       
        <DialogContent style={{padding:'0' }}>
          <Stack spacing={2} padding={1}>
            <TextField
            fullWidth
              id="outlined-basic"
              value={categoryName}
              name="categoryName"
              select
              onChange={handleChangeCategory}
              size="small"
              label={categoryError ? categoryError : "Select Category"}
              error={!!categoryError}
              variant="outlined"
              required
            >
              {category.map((pm) => {
                return (
                  <MenuItem key={pm.category_id} value={pm.category_name}>
                    {pm.category_name}
                  </MenuItem>
                );
              })}
            </TextField>
            <TextField
            required
              id="outlined-basic"
              value={brandName}
              name="brandName"
              select
              onChange={handleChangeBrand}
              size="small"
              variant="outlined"
              label={brandError ? brandError : "Select Brand"}
              error={!!brandError}
            >
              {brand.map((pm) => {
                return (
                  <MenuItem key={pm.brand_id} value={pm.brand_name}>
                    {pm.brand_name}
                  </MenuItem>
                );
              })}
            </TextField>
            <TextField
            required
              id="new-field"
              size="small"
              variant="outlined"
              value={productName} // This should now be a proper string
              onChange={(event) => {
                setProductName(event.target.value);
                setProductNameError("");
              }}
              label={productNameError ? productNameError : "Product Name"}
              error={!!productNameError}
              inputProps={{ maxLength: 100 }}
            />

            <TextField
            required
              id="outlined-basic"
              value={attributeName}
              name="attributeName"
              select
              onChange={handleChangeAttribute}
              size="small"
              variant="outlined"
              label={attributeError ? attributeError : "Select Attribute"}
              error={!!attributeError}
            >
              {attribute.map((pm) => {
                return (
                  <MenuItem key={pm.attribute_id} value={pm.attribute_name}>
                    {pm.attribute_name}
                  </MenuItem>
                );
              })}
            </TextField>
            <TextField
            required
              id="outlined-basic"
              value={attributeValueName}
              name="attributeValueName"
              select
              onChange={handleChangeAttributeValue}
              size="small"
              variant="outlined"
              label={
                attributeValueError
                  ? attributeValueError
                  : "Select Attribute Value"
              }
              error={!!attributeValueError}
            >
              {attributeValue.map((pm) => {
                return (
                  <MenuItem
                    key={pm.attribute_value_id}
                    value={pm.attribute_value}
                  >
                    {pm.attribute_value}
                  </MenuItem>
                );
              })}
            </TextField>
            <TextField
            required
              id="outlined-basic"
              value={UMName}
              name="UMName"
              select
              onChange={handleChangeUM}
              size="small"
              variant="outlined"
              label={UMError ? UMError : "Unit of Measurement"}
              error={!!UMError}
            >
              {UM.map((pm) => {
                return (
                  <MenuItem
                    key={pm.measurement_unit_id}
                    value={pm.measurement_unit_name}
                  >
                    {pm.measurement_unit_name}
                  </MenuItem>
                );
              })}
            </TextField>
            <TextField
            required
              id="new-field"
              size="small"
              variant="outlined"
              onChange={(event) => {
                const value = event.target.value;
                setPrice(value);
                setPriceError("");
             
             }} value={price}
              type="number"
              label={priceError ? priceError : "Price"}
              error={!!priceError}
              
            />
            <TextField
            // required
              id="new-field"
              size="small"
              variant="outlined"
              onChange={(event) => {
                const value = event.target.value;
                setQuantity(value);
                }}
              value={quantity}
              type="number"
              label={quantityError ? quantityError : "Quantity"}
              error={!!quantityError}
              disabled={productId}
              inputProps={{ min: 0 }}
             
            />
            <TextField
              id="new-field"
              size="small"
              variant="outlined"
              onChange={(event) => {
                const value = event.target.value;
                setProductDescription(value);
              }}
              value={productDescription}
              label="Description"
              inputProps={{ maxLength: 250 }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "2px",
              }}
            >
              <Button
                className="save_update_btn"
                variant="contained"
                disabled={isLoading}
                onClick={productId? editProduct:saveProduct}
                sx={{ mt: 2 }}
              >
                {/* {productId ? "Update" : "Save"} */}
                {isLoading ? "Saving..." : productId ? "Update" : "Save"}
              </Button>
            </div>
          </Stack>
        </DialogContent>
      </Dialog>

      <Container>
        <div className="product_container">
          <div style={{ display: "flex" }}>
            <TextField
              sx={{ minWidth: 300, mt: 0, mb: 0, pt: 0, pb:0 }}
              label="Search..."
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(event) => {
                setSearchQuery(event.target.value);
                setPage(0);
              }}
              size="small"
              style={{ marginBottom: "0", border: "none" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton type="button" aria-label="search">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="user_mngmt_add_delete_container">
            <Button
              className="generate_barcode_btn"
              variant="contained"
              onClick={() => handleExport(selectedProducts)}
            >
              Generate Barcode
            </Button>

            <Button
              className="blue-btn"
              onClick={() => openAddCategoryModal(true)}
            >
              Add Product
            </Button>
          </div>
        </div>
        {/* {error && <p style={{ color: "red" }}>{error}</p>} */}

        <Box className="table-container">
          <Paper className="table-paper">
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 750 }}>
                <TableHead className="table-header">
                  <TableRow>
                    <TableCell align="center"  className="table-cell">
                      <TableSortLabel
                        className="table-sort-label "
                        active={orderBy === "product_id"}
                        direction={orderBy === "product_id" ? order : "desc"}
                        onClick={() => handleRequestSort("product_id")}
                      >
                        Product Id
                        {orderBy === "product_id" ? (
                          <span style={visuallyHidden}>
                            {order === "desc"
                              ? "sorted descending"
                              : "sorted ascending"}
                          </span>
                        ) : null}
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="center"  className="table-cell">
                      <TableSortLabel 
                        className="table-sort-label "
                        active={orderBy === "product_name"}
                        direction={orderBy === "product_name" ? order : "desc"}
                        onClick={() => handleRequestSort("product_name")}
                      >
                        Product Name
                        {orderBy === "product_name" ? (
                          <span style={visuallyHidden}>
                            {order === "desc"
                              ? "sorted descending"
                              : "sorted ascending"}
                          </span>
                        ) : null}
                      </TableSortLabel>
                    </TableCell>

                    <TableCell  align="center"  className="table-cell">
                      <TableSortLabel 
                        className="table-sort-label "
                        active={orderBy === "category_name"}
                        direction={orderBy === "category_name" ? order : "desc"}
                        onClick={() => handleRequestSort("category_name")}
                      >
                        Category
                        {orderBy === "category_name" ? (
                          <span style={visuallyHidden}>
                            {order === "desc"
                              ? "sorted descending"
                              : "sorted ascending"}
                          </span>
                        ) : null}
                      </TableSortLabel>
                    </TableCell>
                    <TableCell  align="center"  className="table-cell">
                      <TableSortLabel
                        className="table-sort-label "
                        active={orderBy === ""}
                        direction={orderBy === "brand_name" ? order : "desc"}
                        onClick={() => handleRequestSort("brand_name")}
                      >
                        Brand
                        {orderBy === "brand_name" ? (
                          <span style={visuallyHidden}>
                            {order === "desc"
                              ? "sorted descending"
                              : "sorted ascending"}
                          </span>
                        ) : null}
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="center"  className="table-cell">
                      <TableSortLabel
                        className="table-sort-label "
                        active={orderBy === "attribute_name"}
                        direction={
                          orderBy === "attribute_name" ? order : "desc"
                        }
                        onClick={() => handleRequestSort("attribute_name")}
                      >
                        Attribute
                        {orderBy === "attribute_name" ? (
                          <span style={visuallyHidden}>
                            {order === "desc"
                              ? "sorted descending"
                              : "sorted ascending"}
                          </span>
                        ) : null}
                      </TableSortLabel>
                    </TableCell>
                  
                    <TableCell  align="center"  className="table-cell">
                      <TableSortLabel
                        className="table-sort-label "
                        active={orderBy === "mesaurement_unit"}
                        direction={
                          orderBy === "measurement_unit" ? order : "desc"
                        }
                        onClick={() => handleRequestSort("measurement_unit")}
                      >
                        Measurement Unit
                        {orderBy === "measurement_unit" ? (
                          <span style={visuallyHidden}>
                            {order === "desc"
                              ? "sorted descending"
                              : "sorted ascending"}
                          </span>
                        ) : null}
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="center"  className="table-cell">
                      <TableSortLabel
                        className="table-sort-label "
                        active={orderBy === "price"}
                        direction={orderBy === "price" ? order : "desc"}
                        onClick={() => handleRequestSort("price")}
                      >
                        Price
                        {orderBy === "price" ? (
                          <span style={visuallyHidden}>
                            {order === "desc"
                              ? "sorted descending"
                              : "sorted ascending"}
                          </span>
                        ) : null}
                      </TableSortLabel>
                    </TableCell>

                    <TableCell align="center"  className="table-cell">
                      <TableSortLabel
                        className="table-sort-label "
                        active={orderBy === "quantity"}
                        direction={orderBy === "quantity" ? order : "desc"}
                        onClick={() => handleRequestSort("quantity")}
                      >
                        Quantity
                        {orderBy === "quantity" ? (
                          <span style={visuallyHidden}>
                            {order === "desc"
                              ? "sorted descending"
                              : "sorted ascending"}
                          </span>
                        ) : null}
                      </TableSortLabel>
                    </TableCell>

                    <TableCell  align="center" sx={{color:'white'}}>
                     
                        Description
                       
                    </TableCell>
                    <TableCell  align="center"  sx={{color:'white'}}>
                      Barcode
                    </TableCell>
                  </TableRow>
                </TableHead>
                {loading ? (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <CircularProgress size={24} />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
                <TableBody>
  {paginatedRows.map((row, i) => (
    <StyledTableRow
      key={row.product_id}
      style={{ cursor: "pointer" }}
      onClick={(event) => {
        if (event.target.type !== "checkbox") {
          handleSelectRow(
            row.product_id,
            row.product_name,
            row.category_name,
            row.brand_name,
            row.attribute_value,
            row.attribute_name,
            row.measurement_unit,
            row.price,
            row.quantity,
            row.description,
            row.category_id,
            row.attribute_id,
            row.brand_id,
            row.attribute_value_id,
            row.measurement_unit_id
          );
        }
      }}
    >
      <StyledTableCell align="center">{row.product_id}</StyledTableCell>
      <StyledTableCell align="center">{row.product_name}</StyledTableCell>
      <StyledTableCell align="center">{row.category_name}</StyledTableCell>
      <StyledTableCell align="center">{row.brand_name}</StyledTableCell>
      <StyledTableCell align="center">
        {row.attribute_name} : {row.attribute_value}
      </StyledTableCell>
      <StyledTableCell align="center">{row.measurement_unit}</StyledTableCell>
      <StyledTableCell align="center">₹{row.price}</StyledTableCell>
      <StyledTableCell align="center">{row.quantity}</StyledTableCell>
      <StyledTableCell align="center" sx={{padding:'0'}}>
        <Tooltip title={row.description}  placement="top"
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: "white",
              color: "rgb(0 0 0 / 90%)",
              padding: "8px",
              borderRadius: "4px",
              boxShadow: "0px 4px 6px rgba(65, 61, 61, 0.1)",
              fontSize: "14px",
              lineHeight: "1.3",
              width:'90%'
            },
          },
        }} >
          <InfoIcon  style={{ cursor: "pointer", color:'#0a64a2' }} />
        </Tooltip>
      </StyledTableCell>
      <StyledTableCell
        align="center"
        style={{
          padding: "0",
          marginLeft: "0",
          paddingRight: "0px",
        }}
      >
        <Checkbox
          checked={selectedProducts.includes(row.product_id)} // Checked if selected
          onChange={(event) => {
            event.stopPropagation(); // Prevent row click from firing
            handleSelectCheckBox(row); // Toggle selection
          }}
        />
      </StyledTableCell>
    </StyledTableRow>
  ))}
</TableBody>
            )}

                <TableFooter>
                  <TableRow>
                    <TablePagination
                      sx={{
                        backgroundColor: "#0A64A2",
                        color: "white",
                        width: "100%",
                      }}
                      rowsPerPageOptions={[5, 10, 25]}
                      colSpan={11}
                      count={sortedRows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      </Container>

      <Snackbar
        open={showSnackbarMessage}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => {
          setShowSnackbarMessage(false);
        }}
        message={snackbarMessage}
      >
        <Alert
          severity={snackbarMessageColor}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
       {/* Delete Confirmation Dialog */}
  <Dialog
        open={openDeleteDialog}
        onClose={handleCloseConfirm}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px",borderRadius:"5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
           Kindly select the product(s) to generate barcode.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
        
          <Button
          variant="contained"
          onClick={handleCloseConfirm}
          className="no-btn"
          >
            Ok
          </Button>
         
        </DialogActions>
      </Dialog>
    </>
  );
}
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const Container = styled("div")({
  padding: "5rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
});